import React from 'react';
import ReactDOM from 'react-dom/client';

import Main from 'BROWSER_TEST/main';

const run = () => {
  const startFlag = document.getElementById('js_browser_test_start_flag');
  if (!startFlag) {
    return;
  }
  ReactDOM.createRoot(document.getElementById('root')).render(<Main />);
};

export default run;
